export const noop = () => {
	/* noop */
};

export const promiseNoop = () => Promise.resolve(/* noop */);
